export const hiddenByClass = (element) => {
  for (let i = 0; i < element.length; i++) {
    element[i].classList = 'hidden';
  }
};
